import styled from "styled-components"

import { Button, colors, spacing, Text } from "@minuthq/meatball-ui-react"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useTranslate } from "src/domains/i18n/use-translate"
import backdropImage from "src/ui/assets/buildings-orange-brown.jpg"
import { PageLayout } from "src/ui/page-layout/page-layout"

export const Route = createFileRoute("/mfa/")({
  component: MfaList,
})

function MfaList() {
  const navigate = useNavigate()
  const { tPlaceholder } = useTranslate()

  return (
    <PageLayout
      title={tPlaceholder("Multi-factor authentication")}
      description={tPlaceholder(
        "Manage the methods you use to verify your identity when signing in."
      )}
      landscapeImageUrl={backdropImage}
      portraitImageUrl={backdropImage}
    >
      {/* TODO: replace this placeholder with the real enrolled-methods list
          once a GET /auth/account/mfa list endpoint exists. Run
          `yarn update-api-types`, then derive the response type and fetch it
          with `useQuery` following the fetch + act pattern in mfa/setup.tsx. */}
      <MethodList>
        <MethodRow>
          <div>
            <Text variant="body">{tPlaceholder("Authenticator app")}</Text>
            <Text variant="bodyS" color="secondary">
              {tPlaceholder("Not set up yet")}
            </Text>
          </div>
        </MethodRow>
      </MethodList>

      <div>
        <Button
          onClick={() => {
            void navigate({ to: "/mfa/setup" })
          }}
        >
          {tPlaceholder("Set up MFA")}
        </Button>
      </div>
    </PageLayout>
  )
}

const MethodList = styled.div`
  display: grid;
  gap: ${spacing.S};
`

const MethodRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${spacing.M};
  border: 1px solid ${colors.divider};
  border-radius: 8px;
`
